<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.brands') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" height="60vh" :update:sortBy="updateSortBy"
                :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table" fixed-header>
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false" :placeholder="$t('main.search.placeholder')"
                                variant="outlined" hide-details="true" density="compact" class="pb-2 py-0 bg-white"
                                height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="createNewBrand">
                                {{ $t('global.menu.backoffice.createBrand') }}
                            </v-btn>
                            <!-- <CustomFilterMenu :title="'status'" :items="['disabled','published','pending','created']" v-model="filter" :multiple="true"></CustomFilterMenu> -->
                            <!-- {{ filter }} -->
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.controls`]="props">
                    <v-btn color="primary" variant="flat" size="32" class="mr-1" @click="() => editShopBrand(props.item)">
                        <v-icon>mdi-home</v-icon>
                    </v-btn>
                    <v-btn @click="() => editBrand(props.item)" color="primary" variant="flat" size="32" class="mr-1">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn @click="() => removeBrand(props.item)" color="error" variant="flat" size="32" class="mr-1">
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>

            </v-data-table-server>
        </v-row>
        <CreateBrandDialog v-model="showDialog" v-model:data="newBrand" :save="saveBrand"></CreateBrandDialog>
        <CustomConfirmDeletionDialog v-model="showDeleteDialog" v-model:data="removedBrand"
            :confirm-deletion="deleteBrand">
        </CustomConfirmDeletionDialog>
        <AddBrandToShopDialog v-model="showShopBrandDialog" v-model:data="selectedBrand"></AddBrandToShopDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateBrandDialog from './modals/CreateBrandDialog.vue';
import CustomConfirmDeletionDialog from './modals/CustomConfirmDeletionDialog.vue';
import AddBrandToShopDialog from './modals/AddBrandToShopDialog.vue';

export default {
    components: {
        CreateBrandDialog,
        CustomConfirmDeletionDialog,
        AddBrandToShopDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const newBrand = ref({})
        const removedBrand = ref({})
        const showDialog = ref(false)
        const showDeleteDialog = ref(false)
        const showShopBrandDialog = ref(false)
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");
        const selectedBrand = ref(null);

        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        const createNewBrand = () => {
            newBrand.value = { nameTranslations: {} }
            showDialog.value = true;
        }

        const editShopBrand = (brand) => {
            showShopBrandDialog.value = true;
            selectedBrand.value = brand;
        }

        const editBrand = (item) => {
            console.log(item);
            newBrand.value = item
            showDialog.value = true;
        }

        const saveBrand = async () => {
            if (newBrand.value.id) {

                const { areas, ...copy } = newBrand.value;

                // PUT /backoffice/Brands/fccee441-6591-42d1-8c4e-bd3112dfa7f4
                try {
                    const response = await proxy.$axios.put(`/backoffice/brand/${newBrand.value.id}`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });
                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy })
                    }

                } catch (error) {
                    console.error("Error fetching search results:", error);
                }

            } else {
                if (typeof newBrand.value.vouchersAvailable == 'undefined') {
                    newBrand.value.vouchersAvailable = false;
                }
                newBrand.value.fairlingTarget = false;
                newBrand.value.activeInFindeling = false;

                const { areas, ...copy } = newBrand.value;
                try {
                    const response = await proxy.$axios.post(`/backoffice/brand`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy })
                    }

                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            }
        }
        const removeBrand = (item) => {
            removedBrand.value = item;
            showDeleteDialog.value = true;
        }

        const deleteBrand = async (item) => {
            try {
                const response = await proxy.$axios.delete(`/backoffice/brand/${item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    showDeleteDialog.value = false;
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        const updatePage = (newPage) => {
            proxy.page = newPage;
        }


        return {
            selectedLanguage,
            newBrand,
            removedBrand,
            showDialog,
            showDeleteDialog,
            createNewBrand,
            editBrand,
            saveBrand,
            removeBrand,
            deleteBrand,
            updatePage,
            showShopBrandDialog,
            editShopBrand,
            selectedBrand,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        page: 1,
        itemsPerPage: 50,
        sortBy:[],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Name', key: 'name', align: 'start', maxWidth: "200px" },
            // { title: 'URL Name', key: 'urlName', align: 'start' },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            console.log("sortBy",sortBy)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/brands/query" : "/backoffice/brands", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    sortColumn: sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    ...(this.search.length >= 1 ? { search: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>